import { CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MenuItem } from '../../models/menu-item';
import { NgxPermissionsModule } from 'ngx-permissions';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-menu',
  standalone: true,
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    CdkMenu,
    CdkMenuItem,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    NgxPermissionsModule,
  ],
})
export class MenuComponent {
  @Input() menu: MenuItem[] = [];
  @Input() menuClass = 'root-menu';
}
